import React, { FC } from 'react'

import { ImageV3 } from '@Components/Image'
import { Link } from '@Components/Link'
import { Image } from '@Generated/graphql'

import styles from './SubCategoryItem.module.scss'

export interface FacetMenuHighlightItemProps{
  alt: string
  id: string
  image: Image
  imageMobile?: Image
  isMobile?: boolean
  title: string
  url: string
}
export const SubCategoryItem: FC<FacetMenuHighlightItemProps> = ({
  alt,
  id,
  image,
  imageMobile,
  isMobile,
  title,
  url,
}) => {
  const imageUrl = isMobile && imageMobile?.url ? imageMobile.url : image?.url
  return (
    <Link
      analytics={{
        dest_page_type: 'category',
        dest_page_type_id: id!,
        source_id: 'top_link_images',
      }}
      className={styles.facetMenuHighlightItemWrapper}
      draggable={false}
      href={url}
    >
      {imageUrl && <ImageV3 alt={alt} draggable={false} height={75} priority src={imageUrl!} width={80} />}
      <p draggable={false}>{title}</p>
    </Link>
  )
}
